import React, { MouseEvent } from 'react';
import styled from 'styled-components';

const AdditionalGuestsPicker = ({ additionalGuestCount, setGuestCount }: {
  additionalGuestCount: number,
  setGuestCount: (num: number) => void
}) => {

  const handleIncrease = (e: MouseEvent) => {
    e.preventDefault();
    if (additionalGuestCount < 9) {
      setGuestCount(additionalGuestCount + 1);
    }
  };

  const handleDecrease = (e: MouseEvent) => {
    e.preventDefault();
    if (additionalGuestCount > 0) {
      setGuestCount(additionalGuestCount - 1);
    }
  };

  return (
    <>
      <ButtonWrapper>
        <Label>How many people are going?</Label>
        <CounterWrapper>
          <button onClick={handleDecrease} disabled={additionalGuestCount === 0}
                  style={{ margin: '5px' }}>&minus;</button>
          <span>{additionalGuestCount + 1}</span>
          <button onClick={handleIncrease} disabled={additionalGuestCount === 9} style={{ margin: '5px' }}>+</button>
        </CounterWrapper>
      </ButtonWrapper>
    </>
  );
};

const ButtonWrapper = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
`;

const Label = styled.div`
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 5px;
`;

const CounterWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export default AdditionalGuestsPicker;
